export function getDisplayAmount(isFree: boolean, selectedPrice: number) {
  return !isFree ? "$" + (selectedPrice / 100).toFixed(2) : `FREE`;
}
